import { StoreDetailsSectionProps } from './store-details-section.types'
import styles from './store-details-section.module.scss'
import {
  Button,
  EntityInfoNameLine,
  FileStatus,
  IconEdit,
  Input,
  LabeledLine,
  SectionContainer,
  Select,
  TagsEditor,
  Text1,
  Textarea,
  secureString,
} from '@touche-lts/panel-ui/dist'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'
import AvatarEditor from 'react-avatar-editor'
import { ImageTypeDimentions as ImageDimetion } from "models/image-type-dimentions"
import { DropImages, ImagePreview } from 'components'
import { useEffect, useState } from 'react'

const StoreDetailsSectionComponent = (props: StoreDetailsSectionProps) => {
  const { className, style, MyStoreContainerRef } = props
  const [backgroundWidth, SetBackgroundWidth] = useState(null);
  const {
    viewStorePageStore: {
      store,
      storeDetailsEditMode,
      onStoreDetailsEditClick,
      onSaveStoreDetailsClick,
      onCancelStoreDetailsEditingClick,
      setStoreProps,
      setStoreAddressProps,
      setStorePaymentProps
    },
    imagesStore: {
      squareImageLink,
      backgroundImageLink,
      getCropSquareActive,
      getCropBackgroundActive,
      setSquareActive,
      setBackgroundActive,
      setSqureCropEdit,
      setBackgroundCropEdit,
      getPositionSquare,
      getPositionBackground,
      getScaleSquare,
      getScaleBackground,
      setPositionSqure,
      setScaleSqure,
      setPositionBackground,
      setScaleBackground,
      removeSqureImage,
      removeBackgroundImage
  }
  } = useRootStore()

  useEffect(() => {
    const departmentsSquareInfo = store?.squareCrop;
    if(!!departmentsSquareInfo) {
        setSqureCropEdit(departmentsSquareInfo)
    }
    const departmentsBackgroundInfo = store?.backgroundCrop;
    if(!!departmentsBackgroundInfo) {
        setBackgroundCropEdit(departmentsBackgroundInfo)
    }
    SetBackgroundWidth(MyStoreContainerRef?.current?.clientWidth - 24);
  }, [store?.squareCrop, store?.backgroundCrop, setSqureCropEdit, setBackgroundCropEdit, MyStoreContainerRef])

  return (
    <SectionContainer colorPreset='dark' className={className} style={style}>
      {!!backgroundWidth && (
        <>
          {backgroundImageLink ? (
            <>
            {getCropBackgroundActive ? (
                <div className='d-flex flex-column'>
                    <AvatarEditor 
                        width={backgroundWidth} 
                        height={ImageDimetion.BACKGROUND_HEIGHT} 
                        border={0}
                        scale={getScaleBackground}
                        position={getPositionBackground}
                        onPositionChange={(ev) => setPositionBackground(ev)}
                        image={backgroundImageLink}
                        className={styles.coverImage}
                    />
                    <div className={styles.backgroundCropContainer}>
                      <input
                          name="scale"
                          type="range"
                          onChange={(ev) => setScaleBackground(ev.target.value as any)}
                          value={getScaleBackground}
                          min="1"
                          max="3"
                          step="0.01"
                          defaultValue="1"
                          className="py-2 mx-2"
                      /> 
                      <Button onClick={() => {
                        setBackgroundActive(false)
                        onSaveStoreDetailsClick()
                      }}>Crop Background</Button>
                    </div>
                </div>
            ): (
                <ImagePreview 
                    removeCropping={() => console.log('remove')}
                    removeItem={() => {
                      removeBackgroundImage()
                      // onSaveStoreDetailsClick()
                    }}
                    status={FileStatus.UPLOADING}
                    width={backgroundWidth} 
                    height={ImageDimetion.BACKGROUND_HEIGHT} 
                    isSquare={false}
                    openImageEditor={() => setBackgroundActive(true)}
                    className={styles.coverImage}
                />
            )}
            </>
            ) : (
                <DropImages 
                    width={backgroundWidth} 
                    height={ImageDimetion.BACKGROUND_HEIGHT} 
                    onFileDropped={onSaveStoreDetailsClick}
                    square={false} 
                />
            )}
        </>
      )}
      <div className={styles.headingContainer}>
        <div className={styles.containerSquare}>
            {squareImageLink ? (
                <>
                {getCropSquareActive ? (
                    <div className='d-flex flex-column'>
                        <AvatarEditor 
                            width={ImageDimetion.SQUARE_WIDTH} 
                            height={ImageDimetion.SQUARE_HEIGHT} 
                            border={1}
                            scale={getScaleSquare}
                            position={getPositionSquare}
                            onPositionChange={(ev) => setPositionSqure(ev)}
                            image={squareImageLink}
                        />
                        <input
                            name="scale"
                            type="range"
                            onChange={(ev) => setScaleSqure(ev.target.value as any)}
                            value={getScaleSquare}
                            min="1"
                            max="3"
                            step="0.01"
                            defaultValue="1"
                            className="py-2 mx-3"
                        /> 
                        <Button onClick={() => {
                          setSquareActive(false)
                          onSaveStoreDetailsClick()
                        }}>Crop Portrait</Button>
                    </div>
                ): (
                    <ImagePreview 
                        removeCropping={() => console.log('remove')}
                        removeItem={() => {
                          removeSqureImage()
                          // onSaveStoreDetailsClick()
                        }}
                        status={FileStatus.UPLOADING}
                        width={ImageDimetion.SQUARE_WIDTH} 
                        height={ImageDimetion.SQUARE_HEIGHT} 
                        isSquare={true}
                        openImageEditor={() => setSquareActive(true)}
                    />
                )}
                </>
            ) : (
                <DropImages 
                    width={ImageDimetion.SQUARE_WIDTH}  
                    height={ImageDimetion.SQUARE_HEIGHT}
                    onFileDropped={onSaveStoreDetailsClick} 
                    square 
                />
            )}
        </div>
        {/* <StoreLogoImage src={getLogoImageSrcForObj(store)} /> */}
        <EntityInfoNameLine
          colorPreset='dark'
          entityName={store.name}
          ratingProps={{ rating: store.rating, reviewsCnt: store.reviewsCnt }}
          editMode={storeDetailsEditMode}
          nameInputProps={{
            placeholder: 'Store name',
            value: store.name,
            onChange: name => setStoreProps({ name })
          }}
          style={{ width: '100%' }}
        />
        <div className={styles.topRightContainer}>
          {storeDetailsEditMode ? (
            <>
              <Button
                preset='secondary'
                className={styles.button}
                colorPreset='dark'
                onClick={onCancelStoreDetailsEditingClick}
              >
                Cancel
              </Button>
              <Button
                preset='primary'
                className={styles.button}
                onClick={onSaveStoreDetailsClick}
              >
                Save
              </Button>
            </>
          ) : (
            <Button preset='icon' onClick={onStoreDetailsEditClick}>
              <IconEdit fill={styles.white} />
            </Button>
          )}
        </div>
      </div>
      <div className={styles.detailsContainer}>
        <div className={styles.detailsLeft}>
          <LabeledLine
            label='Phone number'
            colorPreset='dark'
            className={styles.labeledLine}
          >
            {storeDetailsEditMode ? (
              <Input
                colorPreset='dark'
                placeholder='Phone number'
                value={store.phoneNumber}
                onChange={phoneNumber => setStoreProps({ phoneNumber })}
              />
            ) : (
              store.phoneNumber || '-'
            )}
          </LabeledLine>
          <LabeledLine
            label='E-mail'
            colorPreset='dark'
            className={styles.labeledLine}
          >
            {store.email || '-'}
          </LabeledLine>
          <LabeledLine
            label='Currency'
            colorPreset='dark'
            className={styles.labeledLine}
          >
            {storeDetailsEditMode ? (
              <Select
                colorPreset='dark'
                options={[{ label: store.currency, value: store.currency }]}
                noNoneOption
                value={store.currency}
              />
            ) : (
              store.currency || '-'
            )}
          </LabeledLine>
          <LabeledLine
            label='Tags'
            preset='tags'
            colorPreset='dark'
            className={styles.labeledLine}
          >
            {!store.tags && !storeDetailsEditMode ? (
              '-'
            ) : (
              <TagsEditor
                colorPreset='dark'
                tags={store.tags}
                editMode={storeDetailsEditMode}
                onChange={tags => setStoreProps({ tags })}
              />
            )}
          </LabeledLine>
          <LabeledLine
            label='Website URL'
            colorPreset='dark'
            className={styles.labeledLine}
          >
            {storeDetailsEditMode ? (
              <Input
                colorPreset='dark'
                placeholder='Website URL'
                value={store.websiteUrl}
                onChange={websiteUrl => setStoreProps({ websiteUrl })}
              />
            ) : (
              store.websiteUrl || '-'
            )}
          </LabeledLine>
          <LabeledLine
            label='Youtube URL'
            colorPreset='dark'
            className={styles.labeledLine}
          >
            {storeDetailsEditMode ? (
              <Input
                colorPreset='dark'
                placeholder='Youtube URL'
                value={store.youtubeURL}
                onChange={youtubeURL => setStoreProps({ youtubeURL })}
              />
            ) : (
              store.youtubeURL || '-'
            )}
          </LabeledLine>
          <LabeledLine
            label='Country'
            colorPreset='dark'
            className={styles.labeledLine}
          >
            {storeDetailsEditMode ? (
              <Input
                colorPreset='dark'
                placeholder='Country'
                value={store.address?.country}
                onChange={country => setStoreAddressProps({ country })}
              />
            ) : (
              store.address?.country || '-'
            )}
          </LabeledLine>
          <LabeledLine
            label='City'
            colorPreset='dark'
            className={styles.labeledLine}
          >
            {storeDetailsEditMode ? (
              <Input
                colorPreset='dark'
                placeholder='City'
                value={store.address?.city}
                onChange={city => setStoreAddressProps({ city })}
              />
            ) : (
              store.address?.city || '-'
            )}
          </LabeledLine>
          <LabeledLine
            label='Address'
            colorPreset='dark'
            className={styles.labeledLine}
          >
            {storeDetailsEditMode ? (
              <Input
                colorPreset='dark'
                placeholder='Address'
                value={store.address?.address}
                onChange={address => setStoreAddressProps({ address })}
              />
            ) : (
              store.address?.address || '-'
            )}
          </LabeledLine>
          <LabeledLine
            label='ZIP code'
            colorPreset='dark'
            className={styles.labeledLine}
          >
            {storeDetailsEditMode ? (
              <Input
                colorPreset='dark'
                placeholder='ZIP code'
                value={store.address?.zip}
                onChange={zip => setStoreAddressProps({ zip })}
              />
            ) : (
              store.address?.zip || '-'
            )}
          </LabeledLine>
        </div>
        <div className={styles.detailsLeft}>
        <LabeledLine label='Shop description' preset='tags' colorPreset='dark'>
          {storeDetailsEditMode ? (
            <Textarea
              colorPreset='dark'
              style={{ minHeight: 200 }}
              value={store.info}
              onChange={info => setStoreProps({ info })}
            />
          ) : (
            <Text1 colorPreset='dark' style={{ marginTop: 5}}>
              {store.info || '-'}
            </Text1>
          )}
        </LabeledLine>

        {/* Payment Details */}
        <LabeledLine label='Payment username'  colorPreset='dark' className={styles.labeledLine}>
          {storeDetailsEditMode ? (
           <Input
           colorPreset='dark'
           placeholder='Username'
           value={store?.paymentDetails?.username}
           onChange={username => setStorePaymentProps({ username })}
         />
          ) : (
            store?.paymentDetails?.username || '-'
          )}
        </LabeledLine>
        <LabeledLine label='Payment password' colorPreset='dark' className={styles.labeledLine}>
          {storeDetailsEditMode ? (
           <Input
           colorPreset='dark'
           placeholder='Password'
           value={store?.paymentDetails?.password}
           onChange={password=> setStorePaymentProps({ password })}
         />
          ) : (
            secureString(store?.paymentDetails?.password) || '-'
          )}
        </LabeledLine>
        <LabeledLine label='Payment businessID' colorPreset='dark' className={styles.labeledLine}>
          {storeDetailsEditMode ? (
           <Input
           colorPreset='dark'
           placeholder='Business ID'
           value={store?.paymentDetails?.businessId}
           onChange={businessId=> setStorePaymentProps({ businessId })}
         />
          ) : (
            store?.paymentDetails?.businessId || '-'
          )}
        </LabeledLine>
        <LabeledLine label='Payment token' colorPreset='dark' className={styles.labeledLine}>
          {storeDetailsEditMode ? (
           <Input
           colorPreset='dark'
           placeholder='Token'
           value={store?.paymentDetails?.token}
           onChange={token=> setStorePaymentProps({ token })}
         />
          ) : (
            secureString(store?.paymentDetails?.token) || '-'
          )}
        </LabeledLine>

        {/* Shopify Details */}
        <LabeledLine label='Shopify store URL' colorPreset='dark' className={styles.labeledLine}>
          {storeDetailsEditMode ? (
           <Input
           colorPreset='dark'
           placeholder='Shopify Store URL'
           value={store?.shopifyStoreUrl}
           onChange={shopifyStoreUrl => setStoreProps({ shopifyStoreUrl })}
         />
          ) : (
            store?.shopifyStoreUrl || '-'
          )}
        </LabeledLine>
        <LabeledLine label='Shopify access token' colorPreset='dark' className={styles.labeledLine}>
          {storeDetailsEditMode ? (
           <Input
           colorPreset='dark'
           placeholder='Shopify Access Token'
           value={store?.shopifyAccessToken}
           onChange={shopifyAccessToken => setStoreProps({ shopifyAccessToken })}
         />
          ) : (
            secureString(store?.shopifyAccessToken)|| '-'
          )}
        </LabeledLine>
        <LabeledLine label='Shopify API secret' colorPreset='dark' className={styles.labeledLine}>
          {storeDetailsEditMode ? (
           <Input
           colorPreset='dark'
           placeholder={store?.shopifyAccessToken ? "You can't see this key for security reasons." : "Shopify API Secret Key"}
           value={store?.shopifySecretKey}
           onChange={shopifySecretKey => setStoreProps({ shopifySecretKey })} // For security reasons
         />
          ) : (
            secureString(store?.shopifyAccessToken) || '-'
          )}
        </LabeledLine>
        <LabeledLine label='Shopify storefront token' colorPreset='dark' className={styles.labeledLine}>
          {storeDetailsEditMode ? (
           <Input
           colorPreset='dark'
           placeholder='Shopify Storefront Token'
           value={store?.shopifyStorefrontToken}
           onChange={shopifyStorefrontToken => setStoreProps({ shopifyStorefrontToken })}
         />
          ) : (
            secureString(store?.shopifyStorefrontToken) || '-'
          )}
        </LabeledLine>
        </div>
      </div>
    </SectionContainer>
  )
}

const StoreDetailsSection = observer(StoreDetailsSectionComponent)
export { StoreDetailsSection }
